module.exports = __webpack_public_path__ + "static/img/8.d99d6fe.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/5/1/sp/8.png
// module id = Wt/+
// module chunks = 0